import { render, staticRenderFns } from "./LegalButton.vue?vue&type=template&id=eef94ca4&scoped=true"
import script from "./LegalButton.vue?vue&type=script&lang=ts"
export * from "./LegalButton.vue?vue&type=script&lang=ts"
import style0 from "./LegalButton.vue?vue&type=style&index=0&id=eef94ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef94ca4",
  null
  
)

export default component.exports